// styling
import styles from './style.module.scss';

// components
import ItemsGridItem from './ItemsGridItem';

const ItemsGrid = ({ images }) => {

    return (
        <div className={`${styles.grid} items-grid`} id="items">
            {
                images?.map((img, index) => (
                    <ItemsGridItem key={index} item={img} index={index} />
                ))
            }
        </div>
    )
}

export default ItemsGrid